module.exports = __webpack_public_path__ + "static/social_influencer-47602ee827e6b5208eb26873ae4cfaf0.svg";